import { PrismicRichText } from '@prismicio/react';
import * as prismicR from '@prismicio/richtext';

import { PrismicNextImage } from '@prismic/components/PrismicNextImage';

import { Tabs, Tab } from '@components/atoms/Tabs';
import { CardHeader } from '@components/molecules/CardHeader';
import { Overlay } from '@components/organisms/Overlay';

import * as S from './styles';
import { IProps } from './types';
import { getIcon } from './icon';

export const AttributeMessage: React.FC<IProps> = ({
  show,
  hide,
  target,
  attribute,
}: IProps) => {
  const tabs = attribute?.body || [];

  return (
    <Overlay position="fit" show={show} hide={hide} target={target}>
      <S.Modal>
        <CardHeader onHide={hide}>
          {attribute?.header && (
            <span>{prismicR.asText(attribute.header)}</span>
          )}
        </CardHeader>
        <S.Wrapper>
          {tabs && (
            <Tabs>
              {tabs.map((tab, i) => (
                <Tab
                  title={prismicR.asText(tab.primary.tab_title)}
                  key={prismicR.asText(tab.primary.tab_title)}
                >
                  {tab?.primary?.tab_message && (
                    <S.Header>
                      {getIcon('warning')}
                      {prismicR.asText(tab.primary.tab_message)}
                    </S.Header>
                  )}
                  <S.Container columns={tab?.fields.length || 0}>
                    {tab?.fields &&
                      tab.fields.map((item, i) => (
                        <S.Card
                          key={`${prismicR.asText(tab.primary.tab_title)}-${i}`}
                        >
                          {item?.tab_image && (
                            <S.Image>
                              <PrismicNextImage
                                field={item.tab_image}
                                style={{ maxWidth: '100%', height: '100%' }}
                              />
                            </S.Image>
                          )}
                          {item?.tab_name && (
                            <S.Name>
                              {item?.tab_icon && getIcon(item?.tab_icon)}
                              {prismicR.asText(item.tab_name)}
                            </S.Name>
                          )}
                          {item?.tab_content && (
                            <S.Content>
                              <PrismicRichText field={item.tab_content} />
                            </S.Content>
                          )}
                          {item?.tab_footer && (
                            <S.Footer>
                              <PrismicRichText field={item.tab_footer} />
                            </S.Footer>
                          )}
                        </S.Card>
                      ))}
                  </S.Container>
                </Tab>
              ))}
            </Tabs>
          )}
        </S.Wrapper>
      </S.Modal>
    </Overlay>
  );
};
